export function htmlDecode(html: string | undefined): string | undefined {
  if (!html) return html;

  // Check if DOMParser is available (browser environment)
  if (typeof DOMParser === 'undefined') return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Safely get textContent
  return doc?.documentElement?.textContent ?? html;
}
